document.addEventListener('DOMContentLoaded', function() {
  const updateCartBtn = document.getElementById('UpdateCartPromo');
  const removeGiftBtn = document.querySelector('[data-remove-gift]');

  if (!updateCartBtn) {
    return;
  }

  updateCartBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const $form = $('#' + updateCartBtn.dataset.formId);
    
    // Check if the customer explicitly removed the free gift. 
    // If they did then they'll have to explicitly add it to get it back.
    if ($form.find('[data-gift]').val() === '0') {
      sessionStorage.setItem('reject-gift', 'true');
    }

    $.ajax({
      url: $form.attr('action'),
      type: 'post',
      data: $form.serialize(),
      success: onCartSuccess,
      error: onCartError
    });
  });

  // Promos should still be verified after a line item is removed.
  $('[data-remove-line]').click(function(e) {
    const line = parseInt($(this).attr('data-remove-line'), 10);

    if (isNaN(line)) {
      return;
    }

    e.preventDefault();

    $.ajax({
      url: '/cart/change.js',
      type: 'post',
      data: { line, quantity: 0 },
      success: onCartSuccess,
      error: onCartError
    });
  });

  if (removeGiftBtn) {
    removeGiftBtn.addEventListener('click', function() {
      sessionStorage.setItem('reject-gift', 'true');
      // Use the default event to remove this item.
    });
  }

  function onCartSuccess() {
    if (sessionStorage.getItem('reject-gift')) {
      location.replace('/cart');
      return;
    }
    $.get('/cart.js', null, verifyPromos, 'json');
  }

  function onCartError() {
    location.replace('/cart');
  }

  function verifyPromos(cart) {
    if (!cart) {
      location.replace('/cart');
      return;
    }

    const giftVariantID = parseInt(updateCartBtn.dataset.giftVariantId, 10);
    let totalPrice = cart.total_price;

    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      
      if (item.product_type === 'KOHO') {
        totalPrice -= item.final_line_price;
        continue;
      }

      if (item.variant_id === giftVariantID && item.properties['_Gift']) {
        location.replace('/cart');
        return;
      }
    }

    if (totalPrice < 9500.0) {
      location.replace('/cart');
      return;
    }

    // Line item properties "_Gift" must be added here so it's persistant accross cart script runs. See HH-446
    $.post('/cart/add.js', { id: giftVariantID, quantity: 1, properties: {'_Gift': 'true'}}, null, 'json').done(function() {
      location.replace('/cart');
    });
  }
});
